import _ from 'lodash';
import { fork, put, takeEvery } from 'redux-saga/effects';

import * as IwDataDogLogger from './IwDataDogLogger';
import { getStateKey } from '../utils/Api';

function* takeContextFetch() {
    yield takeEvery('api/GET_CONTEXT [success]', function* (action) {
        const state_key = _.get(action, 'payload.state_key');
        IwDataDogLogger.addToGlobalScope('state_key', state_key);
    });
}

function* takeUIStateFetch() {
    yield takeEvery('UI_STATE_FETCH_SUCCEED', function* (action) {
        const step = _.get(action, 'ui.activeStep.id', 'none');
        yield put({ type: `page/SIGNUP_STEP_${getMacroCase(step)} [done]` });
    });
}

function* takeNextStep() {
    yield takeEvery('NEXT_STEP', function* (action) {
        //TODO: temporary hardcoded
        const stepId = _.get(action, 'nextStepId', 'none');
        yield put({ type: `page/SIGNUP_STEP_${getMacroCase(stepId)} [done]` });
    });
}

function* takeSelectStep() {
    yield takeEvery('SELECT_STEP', function* (action) {
        const step = _.get(action, 'selectedStep.id', 'none');
        yield put({ type: `page/SIGNUP_STEP_${getMacroCase(step)} [done]` });
    });
}

export default [
    fork(takeContextFetch),
    fork(takeUIStateFetch),
    fork(takeNextStep),
    fork(takeSelectStep),

    forkEveryInfo(isPageLoadedAction, 'page_loaded_saga'),
    forkEveryInfo(isModalLoadedAction, 'modal_loaded_saga')
];

function isPageLoadedAction(action) {
    return /page\/.+ \[done\]/.test(action.type);
}

function isModalLoadedAction(action) {
    return /modals\/OPEN_POPUP.+ \[done\]/.test(action.type);
}

function forkEveryInfo(checkAction, reporter) {
    return fork(function* () {
        yield takeEvery(checkAction, function* (action) {
            const stateKey = getStateKey();

            yield IwDataDogLogger.logInfo({
                message: action.type,
                tags: {
                    reporter: reporter,
                    impersonating: undefined,
                    stateKey: stateKey
                }
            });
        });
    });
}

function getMacroCase(text) {
    return text
        .replace(
            /([^A-Z_])([A-Z])/g,
            (allMatch, beforeCapital, toCapitalise) =>
                `${beforeCapital}_${toCapitalise}`
        )
        .toUpperCase();
}
